/***********************************
Locations Map Module
************************************/

Quad.PeoplePortraits = ( function() {

  // PRIVATE VARS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  var $portraits,
  $contents,
  commonHeight = 0,
  imageHeightCoef = 1,
  rowLength = 4;

  // PRIVATE METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  function _init() {

    //$("img").removeAttr('srcset');
    //$("img").prop("src", function(i, oldVal) { return oldVal.replace( 'http://localhost:3000', 'http://quad.server3.northernground.net' ); });

    $portraits = $( '#people' ).find( '.portrait' );
    $contents = $( '#people' ).find( '.person-content' );

    //resize();
    //$(window).on('resize', function() { resize(); });

  }

  function resize() {
    $.each( $contents, function( i ) {
      var height = $( this ).outerHeight();
      commonHeight = ( commonHeight == 0 || commonHeight < height ) ? height : commonHeight;

      if (( i+1 ) % 4 == 0 ) {
        $portraits.css({ height: ( commonHeight*imageHeightCoef ) + 'px' });
        commonHeight = 0;
      }
    });
  }


  // PUBLIC METHODS
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~
  return {

    init: _init

  };

})();
